import { render, staticRenderFns } from "./_1.vue?vue&type=template&id=503d83b0&scoped=true&"
import script from "./_1.vue?vue&type=script&lang=js&"
export * from "./_1.vue?vue&type=script&lang=js&"
import style0 from "./_1.vue?vue&type=style&index=0&id=503d83b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503d83b0",
  null
  
)

export default component.exports